import styled from 'styled-components';
import { blackSphera, whiteSphera } from 'src/utilities/UIStyles/variables/Colors';

export const LibraryContainer = styled.section`
  > h3 {
    color: ${blackSphera};
    width: 60%;
    margin: 8% 20% 3% 20%;
    text-align: center;
    font-weight: normal;
    > span {
      font-weight: bold;
    }
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > h3 {
      margin: 2% 20%;
    }
  }
`;

export const LibraryImgCard = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 80%;
  margin: auto;
  padding-bottom: 5%;
  @media (min-width: 600px) and (max-width: 1024px) {
    padding-bottom: 12%;
  }
  @media (max-width: 600px) {
    display: flex;
    width: 90%;
    padding-bottom: 5%;
  }
`;

export const LibaryCard = styled.section`
  width: 30%;
  margin-top: 5%;
  background-color: ${whiteSphera};
  border-radius: 10px;
  -webkit-box-shadow: 1px 5px 10px 5px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 5px 10px 5px rgba(0, 0, 0, 0.2);
  > figure {
    height: 60%;
    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  > div {
    height: 30%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    > p {
      margin: 5% auto;
      width: 84%;
      text-align: center;
      font-size: 1.5vw;
      color: #576176;
    }
    > a {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 5% 0 0 15%;
      width: 70%;
      padding: 1% 3%;
      font-size: 1.2vw;
      color: ${whiteSphera};
      background-color: ${blackSphera};
      text-decoration: none;
      border-radius: 5px;
    }
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    margin-top: 10%;
    > div {
      > p {
        font-size: 1.2vw;
      }
      > a {
        padding: 2% 3%;
        font-size: 1vw;
      }
    }
  }
  @media (max-width: 600px) {
    width: 70%;
    > figure {
      > img {
      }
    }
    > div {
      > p {
        width: 90%;
        font-size: 4vw;
        margin: 2% 5%;
      }
      > a {
        font-size: 3.5vw;
        margin: 5% 0 0 15%;
      }
    }
  }
`;
